export const blockIconsBusinessandpaymentsCorporateFareNew = (
	<span className='material-symbols-outlined'>corporate_fare</span>
);
